import { initial, set } from 'lodash';
import { DocumentationInterface, FormField, NewFormField, MessageProps, AssistantResponse, UserInterface, OwnerInterface } from '../types';

const getFieldByPath = (fields: FormField[], fieldPath: string[]): FormField | undefined => {
    if (fieldPath.length === 0) {
        return undefined;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    for (const field of fields) {
        if (field.name === currentFieldName) {
            if (remainingPath.length === 0) {
                // We've found the field, return it
                return field;
            } else if ((field.type === 'object' || field.type === 'array') && field.schema) {
                // Recursively navigate into the schema
                return getFieldByPath(field.schema, remainingPath);
            }
        }
    }

    // Field was not found at this level or any nested level
    return undefined;
};

const updateFormFieldValue = (fields: FormField[], fieldPath: string[], newValue: string, setChanges: any, recurse: boolean | undefined ): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    return fields.map(field => {
        // console.log(currentFieldName, field.name)

        if (field.name === currentFieldName) {
            console.log(field)
            if (remainingPath.length === 0) {
                let updatedValue: any;
                if (field.value === null || field.value === undefined) {
                    field.value = initializeFormFields([field])[0].value;
                }
                if (field.type === 'dropdown_multiple') {
                    if (!field.value.includes(newValue)) {
                        updatedValue = [...field.value, newValue];
                    } else {
                        updatedValue = field.value.filter((value: string) => value !== newValue);
                    }

                } else {
                    updatedValue = newValue;
                }

                // add path to field
                field['path'] = fieldPath;
                // add to changes object
                const newField = { ...field, value: updatedValue };
                if (recurse !== true) {
                    setChanges((prev: any) => ({ ...prev, value_modified: [...prev.value_modified.filter((f: any) => f['guid'] != field['guid']), newField] }));
                }
                console.log(updatedValue)
                return newField;
            } else if ((field.type === 'object' || field.type === 'array') && field.schema) {
                return {
                    ...field,
                    schema: updateFormFieldValue(field.schema, remainingPath, newValue, setChanges, true)
                };
            }
        }
        return field;
    });
};

const insertSubSchema = (fields: FormField[], fieldPath: string[], newSchema: FormField[], setChanges: any): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    return fields.map((field) => {
        if (field.name === currentFieldName) {
            if (remainingPath.length === 0) {
                field['path'] = fieldPath;
                // add to changes object
                const newField = { ...field, schema: newSchema };
                setChanges((prev: any) => ({ ...prev, field_modified: [...prev.field_modified.filter((f: any) => f['guid'] != field['guid']), newField] }));
                return newField;
            } else if ((field.type === 'object' || field.type === 'array') && field.schema) {
                return {
                    ...field,
                    schema: insertSubSchema(field.schema, remainingPath, newSchema, setChanges)
                };
            }
        }
        return field;
    });
};

const removeSubSchema = (fields: FormField[], fieldPath: string[], removeSchema: any, setChanges: any): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    console.log(fieldPath)

    return fields.map((field) => {
        console.log(field)
        if (field.name === currentFieldName) {
            if (remainingPath.length === 0) {
                console.log("removeSubSchema Ran")
                field['path'] = fieldPath;
                // add to changes object
                const newField = { ...field, schema: undefined, value: [] };
                setChanges((prev: any) => ({ ...prev, field_modified: [...prev.field_modified.filter((f: any) => f['guid'] != field['guid']), newField] }));
                return newField;
            } else if (field.schema) {
                console.log("removeSubSchema recurse Ran")
                return {
                    ...field,
                    schema: removeSubSchema(field.schema, remainingPath, removeSchema, setChanges)
                };
            }

        }
        return field;
    });
};

const createListItem = (fields: FormField[], fieldPath: string[], newValue: any, setChanges: any): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    console.log(newValue)

    console.log(fieldPath)

    return fields.map((field) => {
        if (field.name === currentFieldName) {
            if (remainingPath.length === 0) {
                if (!Array.isArray(field.value)) {
                    field.value = [];
                }
                field['path'] = fieldPath;
                // add to changes object
                const newField = { ...field, value: [...field.value, { item: newValue }] };
                setChanges((prev: any) => ({ ...prev, list_item_added: [...prev.list_item_added.filter((f: any) => f['guid'] != field['guid']), newField] }));
                return newField;
            } else if (field.type === 'object' && field.schema) {
                return {
                    ...field,
                    schema: createListItem(field.schema, remainingPath, newValue, setChanges)
                };
            }
        }

        return field;
    });
};

const readListItem = (fields: FormField[], fieldPath: string[], selectedItem: any): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    return fields.map((field) => {
        if (field.name === currentFieldName) {
            if (remainingPath.length === 0) {
                console.log("readList Ran")
                return { ...field, schema: selectedItem.item };
            } else if (field.type === 'object' && field.schema) {
                return {
                    ...field,
                    schema: readListItem(field.schema, remainingPath, selectedItem)
                };
            }
        }
        return field;
    });
};

const updateListItem = (fields: FormField[], fieldPath: string[], editValue: any, setChanges: any): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    console.log(editValue)

    return fields.map((field) => {
        if (field.name === currentFieldName) {
            if (remainingPath.length === 0) {
                console.log("updateList Ran")
                field.value[editValue] = { item: field.schema };
                field['path'] = fieldPath;
                // add to changes object
                setChanges((prev: any) => ({ ...prev, list_item_updated: [...prev.list_item_updated.filter((f: any) => f['guid'] != field['guid']), field] }));
                return field;
            } else if (field.schema) {
                return {
                    ...field,
                    schema: updateListItem(field.schema, remainingPath, editValue, setChanges)
                };
            }
        }

        return field;
    });
};

const removeListItem = (fields: FormField[], fieldPath: string[], removeValue: number, setChanges: any): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;
    console.log(fieldPath)

    return fields.map(field => {
        console.log(currentFieldName, field.name)
        if (field.name === currentFieldName) {
            if (remainingPath.length === 0) {
                console.log("removeListItem Ran")
                if (Array.isArray(field.value)) {
                    field.value.splice(removeValue, 1);
                }
                console.log(field.value);
                field['path'] = fieldPath;
                // add to changes object
                const newField = { ...field, value: field.value };
                setChanges((prev: any) => ({ ...prev, list_item_deleted: [...prev.list_item_deleted.filter((f: any) => f['guid'] != field['guid']), newField] }));
                return newField;
            } else if (field.type === 'object' && field.schema) {
                console.log("removeListItem recurse Ran")
                return {
                    ...field,
                    schema: removeListItem(field.schema, remainingPath, removeValue, setChanges)
                };
            }
        }

        return field;
    });
};

const clearListSchema = (fields: FormField[], fieldPath: string[], newValue: string): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    return fields.map((field) => {
        console.log(currentFieldName, field.name);
        if (currentFieldName === field?.name && field.schema) {
            if (remainingPath.length === 0) {
                console.log(newValue);
                return { ...field, schema: field.schema.map((schemaField: any) => ({ ...schemaField, value: "" })) };
            } else if ((field.type === 'object' || field.type === 'array') && field.schema) {
                return {
                    ...field,
                    schema: clearListSchema(field.schema, remainingPath, newValue)
                };
            }
        }

        return field as FormField;
    });
};

// Add field to schema
const addField = (fields: FormField[], fieldPath: string[], newField: NewFormField, setChanges: any): FormField[] => {

    //
    if (fieldPath.length === 0) {
        return fields;
    }

    console.log(newField.type)

    const [currentFieldName, ...remainingPath] = fieldPath;

    if (remainingPath.length === 0) {

        newField.order = fields.length + 1;

        const initializedField = initializeFormFields([newField as FormField])[0];

        return [...fields, initializedField];
    }

    return fields.map((field: FormField | undefined) => {
        if (currentFieldName === field?.name) {
            if (remainingPath.length === 0) {

            } else if ((field.type === 'object' || field.type === 'array') && field.schema) {
                return {
                    ...field,
                    schema: addField(field.schema, remainingPath, newField, setChanges)
                };
            }
        }
        return field as FormField;
    });

};

const editField = (fields: FormField[], fieldPath: string[], editedField: FormField, setChanges: any): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    return fields.map((field: FormField | undefined) => {
        if (currentFieldName === field?.name) {
            if (remainingPath.length === 0) {

                console.log(field.value)
                if (editedField.value === null) {
                    editedField.value = initializeFormFields([editedField] as FormField[])[0].value;
                };

                console.log(editedField)

                console.log({ ...field, ...editedField })
                field['path'] = fieldPath;
                // add to changes object
                const newField = { ...field, ...editedField };
                // adds to field_modified and removes from value_modified.
                setChanges((prev: any) => ({ ...prev, field_modified: [...prev.field_modified.filter((f: any) => f['guid'] != field['guid']), newField], value_modified: [...prev.value_modified.filter((f: any) => f['guid'] != field['guid'])] }));
                return newField;
            } else if ((field.type === 'object' || field.type === 'array') && field.schema) {
                return {
                    ...field,
                    schema: editField(field.schema, remainingPath, editedField, setChanges)
                };
            }
        }
        return field as FormField;
    });
};

const deleteField = (fields: FormField[], fieldPath: string[], field: FormField, setChanges: any): FormField[] => {
    if (fieldPath.length === 0) {
        return fields;
    }

    const [currentFieldName, ...remainingPath] = fieldPath;

    return fields.map((field: FormField | undefined) => {
        if (currentFieldName === field?.name) {
            if (remainingPath.length === 0) {
                console.log("deleteField Ran");
                field['path'] = fieldPath;
                // add to changes object
                setChanges((prev: any) => ({ ...prev, field_deleted: [...prev.field_deleted.filter((f: any) => f['guid'] != field['guid']), field] }));
                return undefined as unknown as FormField;
            } else if ((field?.type === 'object' || field?.type === 'array') && field?.schema) {
                return {
                    ...field,
                    schema: deleteField(field.schema, remainingPath, field, setChanges)
                };
            }
        }
        return field as FormField;
    }).filter(Boolean) as FormField[];
};

interface OrderUpdate {
    startIndex: number;
    endIndex: number;
};

const updateFieldOrder = (fields: FormField[], fieldPath: string[], orderUpdate: OrderUpdate): FormField[] => {

    const [currentFieldName, ...remainingPath] = fieldPath;

    if (remainingPath.length === 0) {
        const { startIndex, endIndex } = orderUpdate;
        const updatedFields = Array.from(fields);
        const [fieldToMove] = updatedFields.splice(startIndex, 1);
        updatedFields.splice(endIndex, 0, fieldToMove);

        console.log(`Moving field from ${startIndex} to ${endIndex}`);
        console.log(updatedFields.map(f => f.name));

        for (let i = 0; i < updatedFields.length; i++) {
            updatedFields[i].order = i;
        }

        return updatedFields;
    }

    return fields.map(field => {
        if (field.name === currentFieldName) {
            if ((field.type === 'object' || field.type === 'array') && field.schema) {
                return {
                    ...field,
                    schema: updateFieldOrder(field.schema, remainingPath, orderUpdate),
                };
            }
        }
        return field;
    });
};

const initializeFormFields = (schemaFields: FormField[]) => {
    return schemaFields.map((field) => {
        let initialValue: any = '';

        if (field.type === 'short_text' || field.type === 'dropdown_single' || field.type === 'textarea') {
            initialValue = field.value ? field.value : '';
        } else if (field.type === 'number') {
            initialValue = field.value ? field.value : 0;
        } else if (field.type === 'boolean') {
            initialValue = field.value ? field.value : false;
        } else if (field.type === 'object' || field.type === 'array' || field.type === 'dropdown_multiple') {
            initialValue = field.value ? field.value : [];
            if (typeof field.value === 'string') {
                // Convert string to array
                initialValue = field.value.split(',');
                console.log(initialValue)
            }
        }

        return {
            ...field,
            value: initialValue
        };
    });
};


export { getFieldByPath, updateFormFieldValue, insertSubSchema, removeSubSchema, createListItem, readListItem, updateListItem, removeListItem, clearListSchema, addField, editField, deleteField, updateFieldOrder, initializeFormFields };